<template>
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
        <p v-if="error">{{ error }}</p>
        <p v-else>Redirecting...</p>
    </div>
</template>

<script>
import { handleSocialOAuthCallback } from '@/utils/socialOAuthCallback';

export default {
    data() {
        return {
            error: '',
        };
    },
    created() {
        handleSocialOAuthCallback('google').catch((err) => {
            this.error = err.message;
            setTimeout(() => {
                window.location.href = '/';
            }, 3000);
        });
    },
};
</script>
